import {createSelector} from '@reduxjs/toolkit';
import {selectDomain} from '.';
import {CalendarSupplier} from 'features/stock/types/calendar-supplier';

export default createSelector([selectDomain], domain => {
  const suppliers = Object.values(domain.selectedSuppliers).filter(s => !!s);
  return suppliers as CalendarSupplier[];
});
